import api from 'app/api';
import store from 'app/store';

export const saveProfile = async (payload, callback) => {
  const successCallback = ({ data }) => {
    store.dispatch({ type: 'APP:USER_DATA:SET', data });

    if (callback) callback(data);
  };

  await api.put(
    `/user/edit-profile`,
    payload,
    {
      id: 'save-user-data',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
    },
  );
};